// Bundle the local HTML document as a static asset.
// eslint-disable-next-line import/no-webpack-loader-syntax
import aiUsageUrl from '!!file-loader!../Learn/articles/ai-usage.html';
// eslint-disable-next-line import/no-webpack-loader-syntax
import yourOwnDomainUrl from '!!file-loader!../Learn/articles/your-own-domain.html';

export const articleCategories = ['Using AI', 'Domains & Websites'] as const;

export type ArticleCategory = typeof articleCategories[number];

export interface Article {
  slug: string;
  contentUrl: string;
  title: string;
  description: string;
  category: ArticleCategory;
  /** Publication date in YYYY-MM-DD format. */
  date: string;
}

// Add published articles here, newest first.
export const articles: Article[] = [{
  slug: 'your-own-domain',
  contentUrl: yourOwnDomainUrl,
  title: 'Your Own Domain: A Small Investment in a Professional Presence',
  description: 'Build a memorable, consistent identity with an affordable custom domain—even if it simply forwards to your booking page, store, or social profile.',
  category: 'Domains & Websites',
  date: '2026-10-10',
}, {
  slug: 'ai-usage',
  contentUrl: aiUsageUrl,
  title: 'Beyond "Just Google It": How to Master AI Prompts, Save Tokens, and Get Better Answers',
  description: 'Learn practical strategies for managing AI chat context, crafting better prompts, and reviewing AI-generated answers.',
  category: 'Using AI',
  date: '2026-09-08',
}];
